<template>
  <div>
    <Form :description-title="'Atualize os dados do seu setor'">
      <CreateButton
        @click="updateSector()"
        :icon="PhNotePencil"
        :label="'Atualizar'"
      />
    </Form>
  </div>
</template>

<script setup>
import ExtinguisherService from "../service/extinguisher.service";
import CreateButton from "@/components/Buttons/Create.vue";
import Form from "../components/RegisterForm.vue";
import {
  cleanAllFormFields,
  setFormFieldsError,
  validateFormField,
} from "@/helpers/formFieldsHandler";
import { showToast as toast } from "@/helpers/UseToasts";
import { PhNotePencil } from "@phosphor-icons/vue";
import { dataExtinguisher } from "../store";
import { storeApp } from "@/store";
import * as yup from "@/validator";

const store = dataExtinguisher.state;
const appStore = storeApp.state;

const schema = yup.object().shape({
  sectorForm: yup.object().shape({
    name: yup.string().required("Informe o nome do setor").label("Nome"),
    priority: yup.object().required("Informe a prioridade").label("Prioridade"),
  }),
});

async function updateSector() {
  appStore.loading = true;

  cleanAllFormFields();
  const validate = await validateFormField(schema, store);

  if (validate && validate.length > 0) {
    setFormFieldsError(validate);
    appStore.loading = false;
    return;
  }

  // fluxo da imagem
  if (
    store.sectorForm.image &&
    store.hasImage != "[]" &&
    store.hasImage != undefined &&
    typeof store.sectorForm.image === "object" &&
    typeof store.sectorForm.imageName === "string"
  ) {
    await ExtinguisherService.editImage(
      store.sectorForm.image,
      store.oldImage
    )
      .then((res) => {
        store.sectorForm.imageName = res.data;
        store.sectorForm.image = res.data;
      })
      .catch((err) => toast("Aviso", "Imagem não foi salva", "error"));
  } else if (
    store.hasImage == "[]" ||
    (store.hasImage == undefined && typeof store.sectorForm.image == "object")
  ) {
    await ExtinguisherService.saveImage(store.sectorForm.image)
      .then((res) => {
        store.sectorForm.imageName = res.data;
        store.sectorForm.image = res.data;
      })
      .catch((err) => toast("Aviso", "Imagem não foi salva", "error"));
  }

  delete store.sectorForm.imageName;

  await ExtinguisherService.editDataSector(
    store.sectorForm.id,
    store.sectorForm
  )
    .then((res) => {
      if (res?.data?.success) {
        toast("Sucesso", res?.data?.message, "success");

        Promise.allSettled([
          ExtinguisherService.getSectors()
            .then((res) => {
              dataExtinguisher.dispatch("setAllSectors", res.data);
            })
        ]);
      }

      appStore.loading = false;
    })
    .catch((err) => {
      appStore.loading = false;

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast("Aviso", err.response.data.message, "error");
      }

      return toast("Aviso", "Algo deu errado ao registrar documento", "error");
    });
}
</script>
